import { useRef, useEffect, Fragment } from "react";

import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import BreadBanner from "../../component/BreadBanner";
import bg from "../../assets/image/04.jpg";

import img1 from "../../assets/image/course-01.jpg";
import img2 from "../../assets/image/course-02.jpg";
import img3 from "../../assets/image/course-03.jpg";
import img4 from "../../assets/image/course-04.jpg";
import img5 from "../../assets/image/course_8.jpg";
import img6 from "../../assets/image/course_7.jpg";
import img7 from "../../assets/image/course_9.jpg";
import img8 from "../../assets/image/gallery_5.jpg";
import img9 from "../../assets/image/course_3.jpg";
import img10 from "../../assets/image/course_1.jpg";
const Courses = () => {
  return (
    <Fragment>
      <BreadBanner bg={bg} title={"Popular Courses"} />
      <div className="courses">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="courses_search_container">
                <form
                  action="#"
                  id="courses_search_form"
                  className="courses_search_form d-flex flex-row align-items-center justify-content-start"
                >
                  <input
                    type="search"
                    className="courses_search_input"
                    placeholder="Search Courses"
                    required="required"
                  />
                  <select
                    id="courses_search_select"
                    className="courses_search_select courses_search_input"
                  >
                    <option>All Categories</option>
                    <option>Category</option>
                    <option>Category</option>
                    <option>Category</option>
                  </select>
                  <button
                    action="submit"
                    className="courses_search_button ml-auto"
                  >
                    search now
                  </button>
                </form>
              </div>
              <div className="courses_container">
                <div className="row courses_row">
                  <div className="col-lg-6 course_col">
                    <div className="course">
                      <div className="course_image">
                        <img src={img1} alt="" />
                      </div>
                      <div className="course_body">
                        <h3 className="course_title">
                          <Link to={"/courseDetails"}>Software Training</Link>
                        </h3>
                        <div className="course_teacher">Mr. John Taylor</div>
                        <div className="course_text">
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipi
                            elitsed do eiusmod tempor
                          </p>
                        </div>
                      </div>
                      <div className="course_footer">
                        <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                          <div className="course_info">
                            <i
                              className="fa fa-graduation-cap"
                              aria-hidden="true"
                            ></i>
                            <span>20 Student</span>
                          </div>
                          <div className="course_info">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <span>5 Ratings</span>
                          </div>
                          <div className="course_price ml-auto">$130</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 course_col">
                    <div className="course">
                      <div className="course_image">
                        <img src={img2} alt="" />
                      </div>
                      <div className="course_body">
                        <h3 className="course_title">
                          <Link to={"/courseDetails"}>
                            Developing Mobile Apps
                          </Link>
                        </h3>
                        <div className="course_teacher">Ms. Lucius</div>
                        <div className="course_text">
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipi
                            elitsed do eiusmod tempor
                          </p>
                        </div>
                      </div>
                      <div className="course_footer">
                        <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                          <div className="course_info">
                            <i
                              className="fa fa-graduation-cap"
                              aria-hidden="true"
                            ></i>
                            <span>20 Student</span>
                          </div>
                          <div className="course_info">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <span>5 Ratings</span>
                          </div>
                          <div className="course_price ml-auto">Free</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 course_col">
                    <div className="course">
                      <div className="course_image">
                        <img src={img3} alt="" />
                      </div>
                      <div className="course_body">
                        <h3 className="course_title">
                          <Link to={"/courseDetails"}>Starting a Startup</Link>
                        </h3>
                        <div className="course_teacher">Mr. Charles</div>
                        <div className="course_text">
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipi
                            elitsed do eiusmod tempor
                          </p>
                        </div>
                      </div>
                      <div className="course_footer">
                        <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                          <div className="course_info">
                            <i
                              className="fa fa-graduation-cap"
                              aria-hidden="true"
                            ></i>
                            <span>20 Student</span>
                          </div>
                          <div className="course_info">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <span>5 Ratings</span>
                          </div>
                          <div className="course_price ml-auto">
                            <span>$320</span>$220
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 course_col">
                    <div className="course">
                      <div className="course_image">
                        <img src={img4} alt="" />
                      </div>
                      <div className="course_body">
                        <h3 className="course_title">
                          <Link to={"/courseDetails"}>
                            Learn Basic German Fast
                          </Link>
                        </h3>
                        <div className="course_teacher">Mr. John Taylor</div>
                        <div className="course_text">
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipi
                            elitsed do eiusmod tempor
                          </p>
                        </div>
                      </div>
                      <div className="course_footer">
                        <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                          <div className="course_info">
                            <i
                              className="fa fa-graduation-cap"
                              aria-hidden="true"
                            ></i>
                            <span>20 Student</span>
                          </div>
                          <div className="course_info">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <span>5 Ratings</span>
                          </div>
                          <div className="course_price ml-auto">$130</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 course_col">
                    <div className="course">
                      <div className="course_image">
                        <img src={img5} alt="" />
                      </div>
                      <div className="course_body">
                        <h3 className="course_title">
                          <Link to={"/courseDetails"}>Business Groud Up</Link>
                        </h3>
                        <div className="course_teacher">Ms. Lucius</div>
                        <div className="course_text">
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipi
                            elitsed do eiusmod tempor
                          </p>
                        </div>
                      </div>
                      <div className="course_footer">
                        <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                          <div className="course_info">
                            <i
                              className="fa fa-graduation-cap"
                              aria-hidden="true"
                            ></i>
                            <span>20 Student</span>
                          </div>
                          <div className="course_info">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <span>5 Ratings</span>
                          </div>
                          <div className="course_price ml-auto">Free</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 course_col">
                    <div className="course">
                      <div className="course_image">
                        <img src={img6} alt="" />
                      </div>
                      <div className="course_body">
                        <h3 className="course_title">
                          <Link to={"/courseDetails"}>Java Technology</Link>
                        </h3>
                        <div className="course_teacher">Mr. Charles</div>
                        <div className="course_text">
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipi
                            elitsed do eiusmod tempor
                          </p>
                        </div>
                      </div>
                      <div className="course_footer">
                        <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                          <div className="course_info">
                            <i
                              className="fa fa-graduation-cap"
                              aria-hidden="true"
                            ></i>
                            <span>20 Student</span>
                          </div>
                          <div className="course_info">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <span>5 Ratings</span>
                          </div>
                          <div className="course_price ml-auto">
                            <span>$320</span>$220
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row pagination_row">
                  <div className="col">
                    <div className="pagination_container d-flex flex-row align-items-center justify-content-start">
                      <ul className="pagination_list">
                        <li className="active">
                          <a href="#">1</a>
                        </li>
                        <li>
                          <a href="#">2</a>
                        </li>
                        <li>
                          <a href="#">3</a>
                        </li>
                        <li>
                          <a href="#">
                            <i
                              className="fa fa-angle-right"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                      </ul>
                      <div className="courses_show_container ml-auto clearfix">
                        <div className="courses_show_text">
                          Showing <span className="courses_showing">1-6</span>{" "}
                          of <span className="courses_total">26</span> results:
                        </div>
                        <div className="courses_show_content">
                          <span>Show: </span>
                          <select
                            id="courses_show_select"
                            className="courses_show_select"
                          >
                            <option>06</option>
                            <option>12</option>
                            <option>24</option>
                            <option>36</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="sidebar">
                <div className="sidebar_section">
                  <div className="sidebar_section_title">Categories</div>
                  <div className="sidebar_categories">
                    <ul>
                      <li>
                        <a href="#">Art & Design</a>
                      </li>
                      <li>
                        <a href="#">Business</a>
                      </li>
                      <li>
                        <a href="#">IT & Software</a>
                      </li>
                      <li>
                        <a href="#">Languages</a>
                      </li>
                      <li>
                        <a href="#">Programming</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="sidebar_section">
                  <div className="sidebar_section_title">Latest Courses</div>
                  <div className="sidebar_latest">
                    <div className="latest d-flex flex-row align-items-start justify-content-start">
                      <div className="latest_image">
                        <div>
                          <img src={img7} alt="" />
                        </div>
                      </div>
                      <div className="latest_content">
                        <div className="latest_title">
                          <Link to={"/courseDetails"}>
                            How to Design a Logo a Beginners Course
                          </Link>
                        </div>
                        <div className="latest_price">Free</div>
                      </div>
                    </div>

                    <div className="latest d-flex flex-row align-items-start justify-content-start">
                      <div className="latest_image">
                        <div>
                          <img src={img8} alt="" />
                        </div>
                      </div>
                      <div className="latest_content">
                        <div className="latest_title">
                          <Link to={"/courseDetails"}>
                            Photography for Beginners Masterclass
                          </Link>
                        </div>
                        <div className="latest_price">$170</div>
                      </div>
                    </div>

                    <div className="latest d-flex flex-row align-items-start justify-content-start">
                      <div className="latest_image">
                        <div>
                          <img src={img9} alt="" />
                        </div>
                      </div>
                      <div className="latest_content">
                        <div className="latest_title">
                          <Link to={"/courseDetails"}>
                            The Secrets of Body Language
                          </Link>
                        </div>
                        <div className="latest_price">$220</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sidebar_section">
                  <div className="sidebar_section_title">Instagram</div>
                  <div className="sidebar_gallery">
                    <ul className="gallery_items d-flex flex-row align-items-start justify-content-between flex-wrap">
                      <li className="gallery_item">
                        <div className="gallery_item_overlay d-flex flex-column align-items-center justify-content-center">
                          +
                        </div>
                        <a
                          className="colorbox"
                          href="images/gallery_1_large.jpg"
                        >
                          <img src={img4} alt="" />
                        </a>
                      </li>
                      <li className="gallery_item">
                        <div className="gallery_item_overlay d-flex flex-column align-items-center justify-content-center">
                          +
                        </div>
                        <a
                          className="colorbox"
                          href="images/gallery_2_large.jpg"
                        >
                          <img src={img7} alt="" />
                        </a>
                      </li>
                      <li className="gallery_item">
                        <div className="gallery_item_overlay d-flex flex-column align-items-center justify-content-center">
                          +
                        </div>
                        <a
                          className="colorbox"
                          href="images/gallery_3_large.jpg"
                        >
                          <img src={img6} alt="" />
                        </a>
                      </li>
                      <li className="gallery_item">
                        <div className="gallery_item_overlay d-flex flex-column align-items-center justify-content-center">
                          +
                        </div>
                        <a
                          className="colorbox"
                          href="images/gallery_4_large.jpg"
                        >
                          <img src={img3} alt="" />
                        </a>
                      </li>
                      <li className="gallery_item">
                        <div className="gallery_item_overlay d-flex flex-column align-items-center justify-content-center">
                          +
                        </div>
                        <a
                          className="colorbox"
                          href="images/gallery_5_large.jpg"
                        >
                          <img src={img10} alt="" />
                        </a>
                      </li>
                      <li className="gallery_item">
                        <div className="gallery_item_overlay d-flex flex-column align-items-center justify-content-center">
                          +
                        </div>
                        <a
                          className="colorbox"
                          href="images/gallery_6_large.jpg"
                        >
                          <img src={img1} alt="" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="sidebar_section">
                  <div className="sidebar_section_title">Tags</div>
                  <div className="sidebar_tags">
                    <ul className="tags_list">
                      <li>
                        <a href="#">creative</a>
                      </li>
                      <li>
                        <a href="#">unique</a>
                      </li>
                      <li>
                        <a href="#">photography</a>
                      </li>
                      <li>
                        <a href="#">ideas</a>
                      </li>
                      <li>
                        <a href="#">wordpress</a>
                      </li>
                      <li>
                        <a href="#">startup</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Courses;
